import React from 'react';
import queryString from 'query-string';
import { RouteComponentProps } from 'react-router';
import { IRifa } from '../../types/rifa';
import RifaPageContent from './RifaPageContent';
import { getDadosPublicosCampanha } from '../../core/api/CampanhaPublico';
import PageTitle from '../../core/components/PageTitle';
import FeedbackIcon from '../../core/components/FeedbackIcon';

interface State {
	codigoAfiliacao?: string,
	rifa: IRifa,
	error?: string,
	loading: boolean
}

class RifaPage extends React.Component<RouteComponentProps, State> {
	constructor(props: RouteComponentProps) {
   	super(props);

      this.state = {
			loading: false,
			rifa: { }
      }
	}
	
	componentDidMount(): void {
		const {
			location
		} = this.props;
		let numeroRifa;
		let codigoAfiliacao;

		// Testa se o endereço é do formato /10001.xhtml
		if (location.pathname.match("/[0-9]+.xhtml")) {
			numeroRifa = location.pathname.replace(/\D/g, "");
			while (numeroRifa.length < 12) {
				numeroRifa = `0${numeroRifa}`;
			}
		}

		if (location.search) {
			const queryProps = queryString.parse(location.search);

			// Testa se o endereço é do formato /rifa.xhtml?numeroRifa=000000010001
			if (!numeroRifa) 
				numeroRifa = (queryProps.numeroRifa && typeof queryProps.numeroRifa === 'string') ? queryProps.numeroRifa : undefined;

			// Busca o código de afiliação
			codigoAfiliacao = (queryProps.a && typeof queryProps.a === 'string') ? queryProps.a : undefined;
		}

		if (numeroRifa) {
			this.setState({ codigoAfiliacao });
			this.loadRifa(numeroRifa);
		}
	}

	loadRifa = (numeroRifa: string): void => {
		this.setState({ loading: true });

		getDadosPublicosCampanha(numeroRifa)
		.then(response => {
			this.setState({ loading: false, rifa: response });
		})
		.catch(error => {
			this.setState({ 
				loading: false, 
				error: error?.content?.message ?? "Erro ao buscar campanha" 
			});
		}); 
	}

	render(): JSX.Element {
		const { 
			loading, 
			error, 
			rifa, 
			codigoAfiliacao 
		} = this.state;

		if (error) {
			return (
				<div className="page-body-padding text-center">
					<div className="text-center">
						<PageTitle>
							Erro
						</PageTitle>
						<p className="text-muted mb-4">
							{error ?? "Erro ao carregar campanha"}
						</p>

						<FeedbackIcon success={false} />
					</div>
				</div>
			);
		}
		
		return <RifaPageContent rifa={rifa} codigoAfiliacao={codigoAfiliacao} loading={loading} />
	}
}

export default RifaPage;